import { fetchServiceConditions } from 'store/serviceConditions/actions';

import type { universalRouterProps } from 'core/universalRouter/types';

export default ({ store: { dispatch } }: universalRouterProps) => {
  return Promise.all([dispatch(fetchServiceConditions())]);
};
